import gql from 'graphql-tag';

export const createSupplierMember = gql`
  mutation supplierMemberCreate($input: SupplierMemberCreateInput!) {
    supplierMemberCreate(input: $input) {
      success
    }
  }
`;
